module.exports = __webpack_public_path__ + "img/vertical_4_3_7005.7bac7fa0.png";